import { isQbdExtractorJsonUpload } from "@common/constants/financial-documents";
import { TaskFinancialDocument } from "@common/types/task";

export interface SelectedMigrationFile {
    documentId: number;
    fileName: string;
}

export function latestLinkedQbdJsonFile(
    linkedDocuments: TaskFinancialDocument[] = [],
): SelectedMigrationFile | null {
    const latestJsonDocument = linkedDocuments
        .filter((document) =>
            isQbdExtractorJsonUpload({ type: "", name: document.fileName }),
        )
        .reduce<TaskFinancialDocument | null>(
            (latest, document) =>
                !latest || document.createdAt > latest.createdAt
                    ? document
                    : latest,
            null,
        );

    return latestJsonDocument
        ? {
              documentId: latestJsonDocument.id,
              fileName: latestJsonDocument.fileName,
          }
        : null;
}
